import React, { FC } from 'react'
import styled from 'styled-components'
import { Icon, IconSize } from 'uiComponents/atoms/Icon/Icon'
import { IconName } from 'uiComponents/atoms/Icon/IconName'
import {
  backgroundColor,
  bordersColor,
  complementaryColor,
  textBlack,
} from 'uiComponents/constants/colors'
import Dropdown, {
  DropdownContentAlignment,
  IDropdownButtonProps,
} from 'uiComponents/molecules/Dropdown/Dropdown'
import { DropdownOptionType } from 'uiComponents/molecules/Dropdown/types'

const StyledDropdownButton = styled.button`
  display: flex;
  align-items: center;
  border: 1px solid ${bordersColor};
  border-radius: 2px;

  margin: 0 12px 0 0;
  padding: 6px 5px;
  background-color: ${complementaryColor};

  &:hover {
    background-color: ${backgroundColor};
  }

  &:last-child {
    margin: 0;
  }
`

const StyledSortIcon = styled(Icon)`
  width: 16px;
  height: 16px;
  flex: 0 0 16px;
`

const StyledMainIcon = styled(Icon)`
  width: 20px;
  height: 20px;
  flex: 0 0 20px;
  margin-right: 4px;
`

const Value = styled.div`
  color: inherit;
  font-size: 14px;
  line-height: 18px;
  font-weight: 500;
  margin-top: -3px;
`

const renderDropdownButton =
  ({
    isDefaultOptionSelected,
    dropdownIconName,
  }: {
    isDefaultOptionSelected?: boolean
    dropdownIconName?: IconName
  }) =>
  ({ dropdownLabel, getToggleButtonProps }: IDropdownButtonProps) => {
    const colorStyle = {
      color: textBlack,
    }

    return (
      <StyledDropdownButton
        {...getToggleButtonProps()}
        isSelected={isDefaultOptionSelected}
      >
        {dropdownIconName && (
          <StyledMainIcon
            size={IconSize.XS}
            asset={dropdownIconName}
            style={colorStyle}
          />
        )}

        <Value style={colorStyle}>{dropdownLabel}</Value>
        <StyledSortIcon
          size={IconSize.XS}
          asset={IconName.IcSortSmall}
          style={colorStyle}
        />
      </StyledDropdownButton>
    )
  }

const renderSelection = (option: DropdownOptionType) => {
  return <div>{option.label}</div>
}

interface Props {
  options: DropdownOptionType[]
  selectedOption: DropdownOptionType
  onSelect: (option: DropdownOptionType) => void
  dropdownLabel?: string
  dropdownIconName?: IconName
  className?: string
  dataTestId?: string
  isDefaultOptionSelected?: boolean
  contentAlignment: DropdownContentAlignment
  onOpen?: () => void
  onClose?: (option: DropdownOptionType) => void
  onCloseWithoutOption?: () => void
}

const SortingDropdownFilter: FC<Props> = ({
  options,
  selectedOption,
  onSelect,
  dropdownLabel,
  dropdownIconName,
  className,
  dataTestId,
  isDefaultOptionSelected,
  contentAlignment = DropdownContentAlignment.LEFT,
  onClose,
  onCloseWithoutOption,
  onOpen,
}) => {
  const dropdownOptions = [
    {
      options: options,
    },
  ]

  return (
    <Dropdown
      dataTestId={dataTestId ? dataTestId : 'SortingDropdown'}
      placeholder={dropdownLabel}
      dropdownOptions={dropdownOptions}
      onOptionClick={onSelect}
      selection={selectedOption}
      renderDropdownButton={renderDropdownButton({
        isDefaultOptionSelected,
        dropdownIconName,
      })}
      renderSelection={renderSelection}
      className={className}
      dropdownLabel={dropdownLabel}
      contentAlignment={contentAlignment}
      onClose={onClose}
      onCloseWithoutOption={onCloseWithoutOption}
      onOpen={onOpen}
    />
  )
}

export default SortingDropdownFilter
